import { OreButton, OreCardContainer, OreStack, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { navigationRoutes } from '@/Shared/ui/routers'
import { PlusCricleIcon } from '@/Shared/ui/assets/PlusCircle'
import { EnvelopeCheck } from '@/Shared/ui/assets/EnvelopeCheck'

interface TicketsEmptyStateProps {
    text: string
}

export const TicketsEmptyState = ({ text }: TicketsEmptyStateProps): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <OreCardContainer>
            <OreStack
                direction="column"
                space="medium"
                placeItems="center"
                placeContent="center"
                style={{ padding: '2rem' }}>
                <EnvelopeCheck />
                <OreText size="text-lg" tone="neutral-800" align="center">
                    {text}
                </OreText>
                <OreButton
                    category="primary"
                    onClick={() => navigate(navigationRoutes.newTicket)}
                    icon={<PlusCricleIcon />}
                >
                    {t(HelpCenterTranslations.myTickets.emptyStateButton)}
                </OreButton>
            </OreStack>
        </OreCardContainer>
    )
}
